import React, { useRef } from 'react'
import { getImages } from '../Common/const'
import ConsignYourCarForm from '../Components/ConsignYourCar/ConsignYourCarForm'
import SeoMeta from '../Common/SeoMeta';

const ConsignYourCar = () => {
    const sectionRef = useRef(null);
    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <>
            <SeoMeta
                title="Consign Your Car for National Exposure | EEC"
                description="Sell or consign your car with expert guidance. Pricing support, full documentation, professional detailing, national marketing, and buyer negotiation included."
                keywords=""
                ogTitle="Consign Your Car for National Exposure | EEC"
                ogDescription="Sell or consign your car with expert guidance. Pricing support, full documentation, professional detailing, national marketing, and buyer negotiation included."
            />
            <section className="common-banner-wrap repair-banner consign-banner">
                <img src={getImages('consign-hero-image.webp')} alt='Consign Your Vehicle' />
                <div className="container">
                    <div className='common-banner-pos pt-5 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>Consign Your Vehicle</h1>
                        <div className='md-title font-2em fw-400 text-center mt-3 mb-4 wow reveal fadeInUp avenir-next'>What Car do you want to Consign?</div>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase'
                            onClick={scrollToSection}
                            >CLICK TO BEGIN</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className='howitwork-wrap'>
                <div className='container'>
                    <div className='lg-title font-2-5em fw-700 text-uppercase mb-md-5 mb-4 text-center wow reveal fadeInUp'>How it Works</div>
                    <div className='row gx-md-5'>
                        <div className='col-md-6 py-md-4 py-3 wow reveal fadeInUp'>
                            <div className='d-flex align-items-center hiw-box'>
                                <div className='hiw-icon'><img src={getImages('arrow.svg')} /></div>
                                <div>
                                    <div className='sm-title eurostile text-uppercase mb-2'>Decide to Consign or Sell
</div>
                                    <p>Work with one of our experienced professionals to decide which is best for you</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 py-md-4 py-3 wow reveal fadeInUp'>
                            <div className='d-flex align-items-center hiw-box'>
                                <div className='hiw-icon'><img src={getImages('arrow.svg')} /></div>
                                <div>
                                    <div className='sm-title eurostile text-uppercase mb-2'>Let’s Consign </div>
                                    <p>Once you’ve decided to consign your car we will determine the right amount to ask and provide you with the information used to come to that number</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 py-md-4 py-3 wow reveal fadeInUp'>
                            <div className='d-flex align-items-center hiw-box'>
                                <div className='hiw-icon'><img src={getImages('arrow.svg')} /></div>
                                <div>
                                    <div className='sm-title eurostile text-uppercase mb-2'>Agree on Terms</div>
                                    <p>We will present you with the terms of consignment along with full documentation for your signature </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 py-md-4 py-3 wow reveal fadeInUp'>
                            <div className='d-flex align-items-center hiw-box'>
                                <div className='hiw-icon'><img src={getImages('arrow.svg')} /></div>
                                <div>
                                    <div className='sm-title eurostile text-uppercase mb-2'>Detail & Market Your Car</div>
                                    <p>Our Detail Department will get your car looking new! And our Marketing Department will create a full photo set and a detailed description so we can advertise your car with national exposure</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 py-md-4 py-3 wow reveal fadeInUp'>
                            <div className='d-flex align-items-center hiw-box'>
                                <div className='hiw-icon'><img src={getImages('arrow.svg')} /></div>
                                <div>
                                    <div className='sm-title eurostile text-uppercase mb-2'>Sell Your Car</div>
                                    <p>Our Sales Department will negotiate and finalize a deal with the buyer based on the pre-arranged parameters agreed to by you </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 py-md-4 py-3 wow reveal fadeInUp'>
                            <div className='d-flex align-items-center hiw-box'>
                                <div className='hiw-icon'><img src={getImages('arrow.svg')} /></div>
                                <div>
                                    <div className='sm-title eurostile text-uppercase mb-2'>Get You Paid</div>
                                    <p>Once the deal is complete we will wire you your money. If your car has a financing payoff, we will payoff your vehicle, get the title and wire you the equity owed to you</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='consign-car-form-wrap' ref={sectionRef}>
                <div className='container'>
                    <ConsignYourCarForm/>
                </div>
            </section>
        </>
    )
}

export default ConsignYourCar